export default __webpack_public_path__ + "static/media/Hindi_df_1.59d39616.mp3";